import { useInfiniteQuery, useMutation, useQuery } from '@tanstack/react-query'
import { AxiosError } from 'axios'
import { ITutor } from '../../../model/tutor.interface'
import apis from '../../apis'
import { axiosGet, axiosPatch } from '../../axiosHelper'
import { myTutorsQueryApi } from '../../react-query/queryApis'
import { handleAxiosError } from '../axios-util'

type MyTutorsPropsType = {
  experience_tutors: ITutor[]
  my_tutors: ITutor[]
  my_count: number
  tutor_count: number
}

export const useMyTutors = () => {
  return useQuery<MyTutorsPropsType, AxiosError>({
    queryKey: myTutorsQueryApi.getQueryKey(),
    queryFn: myTutorsQueryApi.getQueryFn(),

    // onError: (e) => handleAxiosError(e),
  })
}

export interface IRookieTutorsResponseType {
  success: boolean
  page: number
  tutors: ITutor[]
  count: number
}

export const useRookieTutors = ({ page = 1, limit = 0 }: { page?: number; limit?: number }) => {
  const fetchRookieTutorList = async ({ pageParam = 1, limit }: { pageParam?: number; limit?: number }) => {
    const res = await axiosGet(apis.tutor.rookieTutors({ page: pageParam, limit }))
    return {
      ...res,
      page: pageParam,
    }
  }

  const getRookieTutorCounts = (pages: IRookieTutorsResponseType[]) =>
    pages.map((page: IRookieTutorsResponseType) => page.tutors).flat().length

  return useInfiniteQuery({
    queryKey: [apis.tutor.rookieTutors({ page, limit })],
    queryFn: ({ pageParam = 1 }) => fetchRookieTutorList({ pageParam, limit }),
    getNextPageParam: (lastPage: IRookieTutorsResponseType, allPages: IRookieTutorsResponseType[]) => {
      const { page, count } = lastPage
      const nextPage = page + 1
      const curTotal = getRookieTutorCounts(allPages)
      return count - curTotal > 0 && nextPage
    },
    onError: (e: AxiosError) => handleAxiosError(e),
  })
}

interface TutorNotification {
  tutorId: number
  activate: boolean
}

export const useUpdateTutorNotification = (config = {}) => {
  return useMutation({
    mutationFn: ({ tutorId, activate }: TutorNotification) =>
      axiosPatch(apis.tutor.notification(), { tutor_id: tutorId, activate }),
    ...config,
  })
}
